import getLogger from '@ignitesales/logger-es';

const logger = getLogger();

const mockAppointmentService = {
  getLocations({ location }) {
    return new Promise((resolve) => {
      window.setTimeout(() => {
        const result = [
          {
            id: 1,
            lat: 32.951168,
            lng: -96.801007,
            address: '701 Civic Center Drive',
            city: 'Lake Saint Louis',
            state: 'MO',
            postalCode: '63367',
            name: 'Lake St. Louis'
          },
          {
            id: 2,
            lat: 32.951514,
            lng: -96.820577,
            address: '1001 Canal Boulevard',
            city: 'Thibodaux',
            state: 'LA',
            postalCode: '70',
            name: 'Thibodaux Canal Blvd'
          },
          {
            id: 3,
            lat: 32.957744,
            lng: -96.821092,
            address: '5810 Highway 90',
            city: 'Dallas',
            state: 'AL',
            postalCode: '36582',
            name: 'Theodore - Hamilton Blvd'
          },
          {
            id: 4,
            lat: 32.963542,
            lng: -96.770709,
            address: '8801 SW 136 Street',
            city: 'Miami',
            state: 'FL',
            postalCode: '33176',
            name: 'The Falls'
          },
          {
            id: 5,
            lat: 32.962137,
            lng: -96.770924,
            address: '11447 Springmill Road',
            city: 'Carmel',
            state: 'IN',
            postalCode: '46032',
            name: 'The Bridges At 116Th'
          },
          {
            id: 6,
            lat: 32.948809,
            lng: -96.805041,
            address: '1900 University Boulevard',
            city: 'Birmingham',
            state: 'AL',
            postalCode: '35233',
            name: 'Uab'
          }
        ];
        logger.info('Locations obtained', result);
        resolve(result)
      }, 1000);
    })
  },

  getTimeSlots({ location }) {
    return new Promise((resolve) => {
      window.setTimeout(() => {
        let result = [
          {
            id: 1,
            title: 'Available',
            time: new Date(new Date().setHours(10, 0)),
            length: 60
          },
          {
            id: 2,
            title: 'Available',
            time: new Date(new Date().setHours(new Date().getHours() + 14, 30)),
            length: 60
          },
          {
            id: 3,
            title: 'Available',
            time: new Date(new Date().setHours(new Date().getHours() + 24, 0)),
            length: 60
          },
          {
            id: 4,
            title: 'Available',
            time: new Date(new Date().setHours(new Date().getHours() + 26, 0)),
            length: 60
          },
          {
            id: 5,
            title: 'Available',
            time: new Date(new Date().setHours(new Date().getHours() + 49, 0)),
            length: 60
          },
          {
            id: 6,
            title: 'Available',
            time: new Date(new Date().setHours(new Date().getHours() + 69, 0)),
            length: 60
          },
          {
            id: 7,
            title: 'Available',
            time: new Date(new Date().setHours(new Date().getHours() + 74, 0)),
            length: 60
          },
          {
            id: 8,
            title: 'Available',
            time: new Date(new Date().setHours(new Date().getHours() + 98, 0)),
            length: 60
          }
        ];
        logger.info('Calendar times obtained', result);
        resolve(result)
      }, 1000);
    })
  },

  bookAppointment({ timeSlot }) {
    return new Promise((resolve) => {
      window.setTimeout(() => {
        logger.info('Setting appointment');
        resolve({
          status: true,
          id: '0001'
        })
      }, 1000);
    })
  }
};

export default mockAppointmentService;
